import { ClinicSettingsPresenter } from "@/components/ClinicSettings/components/presenter/ClinicSettingsPresenter"

export const ClinicSettingsViews: React.FC = () => {

    return (
        <ClinicSettingsPresenter />
    )
}
